// extracted by mini-css-extract-plugin
export default {"darkTheme":"Subheader_darkTheme__QBw6W","wrapper":"Subheader_wrapper__841Al","section":"Subheader_section__6js-C","title":"Subheader_title__fCQBr"};